// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =================== PAGE =================== */
.emailconfig-page {
    padding: 0;
    background: transparent;
    min-height: 100%;
}

.ec-page-header {
    margin-bottom: 10px;
}

.ec-header-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.ec-main-title {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 500;
    color: #757575;
}

/* =================== PLUS BUTTON =================== */
.ec-plus-btn {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f59e0b;
    color: #ffffff;
    border: none;
    font-size: 1.35rem;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    box-shadow: 0 4px 10px rgba(245, 158, 11, 0.28);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    flex-shrink: 0;
}

.ec-plus-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(245, 158, 11, 0.4);
}

.ec-plus-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

/* =================== FORM CARD =================== */
.ec-form-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06);
    padding: 14px 18px;
    margin-bottom: 12px;
    max-width: 560px;
}

.ec-section {
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f3f4f6;
}

.ec-section:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.ec-section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.ec-section-title {
    font-size: 0.88rem;
    font-weight: 700;
    color: #374151;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
}

/* =================== FIELDS =================== */
.ec-field-group {
    margin-bottom: 8px;
}

.ec-label {
    display: block;
    font-size: 0.75rem;
    font-weight: 700;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
}

.ec-input {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 0.875rem;
    color: #111827;
    background: #f9fafb;
    box-sizing: border-box;
    outline: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.ec-input:focus {
    border-color: #f59e0b;
    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.12);
    background: #ffffff;
}

.ec-input-error {
    border-color: #ef4444 !important;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
}

.ec-select {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 0.875rem;
    color: #111827;
    background: #f9fafb;
    box-sizing: border-box;
    outline: none;
    cursor: pointer;
}

.ec-select:focus {
    border-color: #f59e0b;
    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.12);
}

/* =================== EMAIL INPUT =================== */
.ec-email-field {
    margin-bottom: 8px;
}

.ec-email-row {
    display: flex;
    gap: 6px;
}

.ec-email-row .ec-input {
    flex: 1 1;
}

.ec-add-btn {
    background: #f59e0b;
    color: #ffffff;
    border: none;
    border-radius: 6px;
    padding: 6px 12px;
    font-weight: 700;
    font-size: 0.85rem;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s ease;
}

.ec-add-btn:hover {
    background: #d97706;
}

.ec-error {
    display: block;
    color: #dc2626;
    font-size: 0.78rem;
    margin-top: 5px;
}

/* =================== CHIPS =================== */
.ec-chip-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 5px;
}

.ec-view-report .ec-view-row {
    flex-direction: column;
    gap: 4px;
}

.ec-view-report .ec-chip-list {
    margin-top: 0;
    flex-direction: row;
    flex-wrap: wrap;
}

.ec-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 999px;
    padding: 2px 8px;
    font-size: 0.78rem;
    color: #374151;
}

.ec-chip-remove {
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 1.05rem;
    line-height: 1;
    color: #9ca3af;
    padding: 0;
    display: flex;
    align-items: center;
}

.ec-chip-remove:hover {
    color: #ef4444;
}

.ec-chip-trigger {
    background: #fff4e6;
    border-color: #fcd34d;
    color: #b45309;
}

/* =================== CHECKBOXES =================== */
.ec-checkboxes {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.ec-checkbox-label {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #f9fafb;
    font-size: 0.82rem;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: border-color 0.15s ease, background 0.15s ease;
}

.ec-checkbox-label:hover {
    border-color: #f59e0b;
    background: #fffbf0;
}

.ec-checkbox-label input[type="checkbox"] {
    appearance: none;
    width: 15px;
    height: 15px;
    border: 2px solid #9ca3af;
    border-radius: 3px;
    background: #ffffff;
    position: relative;
    cursor: pointer;
    flex-shrink: 0;
}

.ec-checkbox-label input[type="checkbox"]:checked {
    background: #f59e0b;
    border-color: #f59e0b;
}

.ec-checkbox-label input[type="checkbox"]:checked::after {
    content: "";
    position: absolute;
    left: 3px;
    top: 0px;
    width: 4px;
    height: 8px;
    border: solid #ffffff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

/* =================== TRIGGER VERTICAL LIST =================== */
.ec-trigger-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
}

.ec-trigger-item {
    border: 1.5px solid #e5e7eb;
    border-radius: 8px;
    background: #f9fafb;
    overflow: hidden;
    transition: border-color 0.15s ease;
}

.ec-trigger-item-active {
    border-color: #f59e0b;
    background: #fffdf7;
}

.ec-trigger-item-label {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    font-size: 0.85rem;
    font-weight: 600;
    color: #374151;
}

.ec-trigger-item-active .ec-trigger-item-label {
    color: #b45309;
}

.ec-trigger-item-matrix {
    border-top: 1px solid #f3f4f6;
}

/* =================== TRIGGER MATRIX BLOCK =================== */
.ec-trigger-matrix-block {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #f9fafb;
    margin-top: 8px;
    overflow: hidden;
}

.ec-trigger-matrix-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 12px;
    background: #f3f4f6;
    border-bottom: 1px solid #e5e7eb;
}

.ec-trigger-matrix-title {
    font-size: 0.78rem;
    font-weight: 700;
    color: #374151;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* keep old .ec-trigger-label for any remaining uses */
.ec-trigger-label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #374151;
}

/* =================== MONTH SUB-GROUP =================== */
.ec-month-subgroup {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 8px;
    background: #fffdf7;
}

.ec-month-subitem {
    background: #ffffff;
}

.ec-month-subitem.ec-trigger-item-active {
    background: #fffdf7;
}

.ec-month-hint {
    font-size: 0.72rem;
    font-weight: 500;
    color: #9ca3af;
    text-transform: none;
    letter-spacing: 0;
}

/* radio used for the mutually-exclusive Month End / Month Start choice */
.ec-radio-check {
    appearance: none;
    width: 15px;
    height: 15px;
    border: 2px solid #9ca3af;
    border-radius: 50%;
    background: #ffffff;
    position: relative;
    cursor: pointer;
    display: inline-block;
    flex-shrink: 0;
}

.ec-radio-check:checked {
    border-color: #f59e0b;
}

.ec-radio-check:checked::after {
    content: "";
    position: absolute;
    left: 3px;
    top: 3px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #f59e0b;
}

/* =================== REPORT FORMAT MATRIX =================== */
.ec-matrix {
    width: 100%;
    border-collapse: collapse;
    margin-top: 0;
    background: #ffffff;
    font-size: 0.8rem;
}

.ec-matrix-th {
    background: #f3f4f6;
    padding: 5px 8px;
    text-align: center;
    font-size: 0.75rem;
    font-weight: 700;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    border-bottom: 1px solid #e5e7eb;
}

.ec-matrix-report-col {
    text-align: left;
    width: 55%;
}

.ec-matrix-fmt-col {
    width: 22%;
}

.ec-matrix-row:not(:last-child) td {
    border-bottom: 1px solid #f3f4f6;
}

.ec-matrix-label {
    padding: 5px 8px;
    font-size: 0.8rem;
    color: #374151;
}

.ec-matrix-cell {
    text-align: center;
    padding: 5px 4px;
}

.ec-matrix-check {
    appearance: none;
    width: 15px;
    height: 15px;
    border: 2px solid #9ca3af;
    border-radius: 3px;
    background: #ffffff;
    position: relative;
    cursor: pointer;
    display: inline-block;
}

.ec-matrix-check:checked {
    background: #f59e0b;
    border-color: #f59e0b;
}

.ec-matrix-check:checked::after {
    content: "";
    position: absolute;
    left: 3px;
    top: 0px;
    width: 4px;
    height: 8px;
    border: solid #ffffff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

/* =================== CUSTOM SCHEDULE =================== */
.ec-custom-sched {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #ffffff;
    padding: 8px 10px;
    margin-top: 8px;
}

.ec-custom-sched-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.ec-custom-sched-title {
    font-size: 0.78rem;
    font-weight: 700;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

.ec-custom-sched-fields {
    display: flex;
    gap: 10px;
    margin-bottom: 8px;
}

.ec-custom-sched-fields .ec-field-group {
    flex: 1 1;
    margin-bottom: 0;
}

/* smaller + button inside trigger header */
.ec-plus-sm {
    width: 22px !important;
    height: 22px !important;
    font-size: 1.1rem !important;
    box-shadow: none !important;
}

/* =================== ICON BUTTONS =================== */
.ec-icon-btn {
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.ec-view-actions {
    display: flex;
    gap: 6px;
    align-items: center;
}

.ec-edit-btn {
    color: #6b7280;
    border: 1px solid #e5e7eb;
    padding: 5px 7px;
    background: #ffffff;
    border-radius: 6px;
}

.ec-edit-btn:hover {
    color: #f59e0b;
    border-color: #fcd34d;
    background: #fffbf0;
}

.ec-delete-btn {
    color: #9ca3af;
    border: 1px solid #e5e7eb;
    padding: 5px 7px;
    background: #ffffff;
    border-radius: 6px;
}

.ec-delete-btn:hover {
    color: #ef4444;
    border-color: #fecaca;
    background: #fef2f2;
}

.ec-remove-btn {
    color: #9ca3af;
    font-size: 0.85rem;
    width: 26px;
    height: 26px;
    border-radius: 6px;
}

.ec-remove-btn:hover {
    color: #ef4444;
    background: #fee2e2;
}

/* =================== EMPTY HINT =================== */
.ec-empty-hint {
    color: #9ca3af;
    font-size: 0.85rem;
    margin: 4px 0 0;
    font-style: italic;
}

/* =================== FORM ACTIONS =================== */
.ec-form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #f3f4f6;
}

.ec-save-btn {
    background: #f59e0b;
    color: #ffffff;
    border: none;
    border-radius: 6px;
    padding: 7px 20px;
    font-weight: 700;
    font-size: 0.9rem;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.25);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.ec-save-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(245, 158, 11, 0.35);
}

.ec-save-btn:disabled {
    background: #d1d5db;
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
}

.ec-cancel-btn {
    background: #f3f4f6;
    color: #374151;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 7px 16px;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.15s ease;
}

.ec-cancel-btn:hover {
    background: #e5e7eb;
}

/* =================== CARDS GRID =================== */
.ec-cards-grid {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

/* =================== VIEW CARD =================== */
.ec-view-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 3px 10px rgba(15, 23, 42, 0.05);
    overflow: hidden;
}

.ec-view-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    border-bottom: 1px solid #f3f4f6;
    background: #f9fafb;
}

.ec-view-title {
    font-size: 0.88rem;
    font-weight: 700;
    color: #111827;
    letter-spacing: 0.3px;
}

.ec-view-body {
    padding: 10px 16px;
    border-bottom: 1px solid #f3f4f6;
}

.ec-view-row {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    margin-bottom: 5px;
}

.ec-view-row:last-child {
    margin-bottom: 0;
}

.ec-view-label {
    font-size: 0.72rem;
    font-weight: 700;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    min-width: 50px;
    padding-top: 3px;
    flex-shrink: 0;
}

.ec-view-value {
    font-size: 0.875rem;
    color: #374151;
}

/* =================== TRIGGER GRID (inside card) =================== */
.ec-view-trigger-grid {
    display: flex;
    border-top: 1px solid #f3f4f6;
    overflow-x: auto;
}

.ec-view-trigger-col {
    flex: 1 1;
    min-width: 140px;
    border-right: 1px solid #f3f4f6;
}

.ec-view-trigger-col:last-child {
    border-right: none;
}

.ec-view-trigger-col-header {
    padding: 6px 12px;
    font-size: 0.72rem;
    font-weight: 700;
    color: #b45309;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    background: #fffbf0;
    border-bottom: 1px solid #fde68a;
}

.ec-view-trigger-col-body {
    padding: 8px 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.ec-view-trigger-report-row {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.ec-view-trigger-report-name {
    font-size: 0.75rem;
    color: #374151;
}

.ec-view-trigger-report-row .ec-chip-list {
    margin-top: 0;
}

.ec-view-trigger-empty {
    font-size: 0.85rem;
    color: #d1d5db;
}

.ec-view-custom-sched-entry {
    padding-bottom: 6px;
    border-bottom: 1px dashed #f3f4f6;
}

.ec-view-custom-sched-entry:last-child {
    padding-bottom: 0;
    border-bottom: none;
}

.ec-view-custom-sched-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    color: #6b7280;
    margin-bottom: 4px;
}

/* =================== DIALOG =================== */
.ec-dialog-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1300;
    padding: 20px;
}

.ec-dialog {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
    width: 100%;
    max-width: 640px;
    min-height: 300px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: ec-dialog-in 0.18s ease;
}

@keyframes ec-dialog-in {
    from { opacity: 0; transform: translateY(12px) scale(0.98); }
    to   { opacity: 1; transform: translateY(0)   scale(1);    }
}

.ec-dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 22px 14px;
    background: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    flex-shrink: 0;
}

.ec-dialog-title {
    font-size: 1rem;
    font-weight: 700;
    color: #111827;
    letter-spacing: 0.2px;
}

.ec-dialog-close {
    color: #9ca3af;
    font-size: 1rem;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, color 0.15s;
}

.ec-dialog-close:hover {
    color: #ef4444;
    background: #fee2e2;
}

.ec-dialog-body {
    overflow-y: auto;
    flex: 1 1;
    padding: 0;
}

.ec-dialog-body::-webkit-scrollbar {
    width: 5px;
}

.ec-dialog-body::-webkit-scrollbar-track {
    background: #f3f4f6;
}

.ec-dialog-body::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 999px;
}

.ec-dialog-body .ec-form-card {
    border: none;
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 0;
    max-width: 100%;
}

.ec-dialog-body .ec-form-card .ec-form-actions {
    padding: 12px 16px;
    margin-top: 0;
    border-top: 1px solid #f3f4f6;
}

/* =================== SWEETALERT SUCCESS =================== */
.emailconfig-success .swal2-title,
.emailconfig-success .swal2-html-container {
    text-align: center !important;
}

.emailconfig-success .swal2-title {
    margin-top: 16px !important;
    margin-bottom: 8px !important;
}

.emailconfig-success .swal2-icon {
    margin-top: 8px !important;
    margin-bottom: 12px !important;
}

.emailconfig-success .swal2-html-container {
    margin-bottom: 8px !important;
}

.emailconfig-success .swal2-actions {
    margin-top: 4px !important;
    justify-content: center !important;
}

.swal2-confirm {
    background: #f97316 !important;
    border-radius: 6px !important;
    padding: 8px 18px !important;
    font-weight: 700 !important;
}

.swal2-cancel {
    background: #6b7280 !important;
    color: #ffffff !important;
    border-radius: 6px !important;
    padding: 8px 18px !important;
    font-weight: 700 !important;
}

/* =================== RESPONSIVE =================== */
@media (max-width: 640px) {
    .ec-form-card,
    .ec-view-card {
        padding: 14px 16px;
    }

    .ec-custom-trigger {
        flex-direction: column;
    }

    .ec-checkboxes {
        gap: 6px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/EmailConfiguration/emailconfig.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;IACI,UAAU;IACV,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,wDAAwD;AACxD;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,+CAA+C;IAC/C,uDAAuD;IACvD,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,sDAAsD;AACtD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,6CAA6C;IAC7C,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,SAAS;AACb;;AAEA,mDAAmD;AACnD;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,iFAAiF;AACrF;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,uDAAuD;AAC3D;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA,wDAAwD;AACxD;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,uDAAuD;AACvD;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,0DAA0D;AAC9D;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA,kEAAkE;AAClE;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,iEAAiE;AACjE;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,sDAAsD;AACtD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA,yEAAyE;AACzE;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,iEAAiE;AACjE;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IAEI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA,4DAA4D;AAC5D;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA,2CAA2C;AAC3C;IACI,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA,yDAAyD;AACzD;IACI,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4EAA4E;AAChF;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,uDAAuD;AACvD;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,+CAA+C;IAC/C,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uDAAuD;AACvD;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,sDAAsD;AACtD;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,SAAW;IACX,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,mDAAmD;AACnD;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,8CAA8C;IAC9C,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,OAAO,UAAU,EAAE,uCAAuC,EAAE;IAC5D,OAAO,UAAU,EAAE,mCAAmC,KAAK;AAC/D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,6BAA6B;AACjC;;AAEA,+DAA+D;AAC/D;;IAEI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA,uDAAuD;AACvD;IACI;;QAEI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,QAAQ;IACZ;AACJ","sourcesContent":["/* =================== PAGE =================== */\n.emailconfig-page {\n    padding: 0;\n    background: transparent;\n    min-height: 100%;\n}\n\n.ec-page-header {\n    margin-bottom: 10px;\n}\n\n.ec-header-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.ec-main-title {\n    margin: 0;\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: #757575;\n}\n\n/* =================== PLUS BUTTON =================== */\n.ec-plus-btn {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background: #f59e0b;\n    color: #ffffff;\n    border: none;\n    font-size: 1.35rem;\n    line-height: 1;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    box-shadow: 0 4px 10px rgba(245, 158, 11, 0.28);\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n    flex-shrink: 0;\n}\n\n.ec-plus-btn:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 14px rgba(245, 158, 11, 0.4);\n}\n\n.ec-plus-btn:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n/* =================== FORM CARD =================== */\n.ec-form-card {\n    background: #ffffff;\n    border-radius: 12px;\n    border: 1px solid #e5e7eb;\n    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06);\n    padding: 14px 18px;\n    margin-bottom: 12px;\n    max-width: 560px;\n}\n\n.ec-section {\n    margin-bottom: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.ec-section:last-of-type {\n    border-bottom: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n\n.ec-section-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.ec-section-title {\n    font-size: 0.88rem;\n    font-weight: 700;\n    color: #374151;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin: 0;\n}\n\n/* =================== FIELDS =================== */\n.ec-field-group {\n    margin-bottom: 8px;\n}\n\n.ec-label {\n    display: block;\n    font-size: 0.75rem;\n    font-weight: 700;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 4px;\n}\n\n.ec-input {\n    width: 100%;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    padding: 6px 10px;\n    font-size: 0.875rem;\n    color: #111827;\n    background: #f9fafb;\n    box-sizing: border-box;\n    outline: none;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.ec-input:focus {\n    border-color: #f59e0b;\n    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.12);\n    background: #ffffff;\n}\n\n.ec-input-error {\n    border-color: #ef4444 !important;\n    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;\n}\n\n.ec-select {\n    width: 100%;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    padding: 6px 10px;\n    font-size: 0.875rem;\n    color: #111827;\n    background: #f9fafb;\n    box-sizing: border-box;\n    outline: none;\n    cursor: pointer;\n}\n\n.ec-select:focus {\n    border-color: #f59e0b;\n    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.12);\n}\n\n/* =================== EMAIL INPUT =================== */\n.ec-email-field {\n    margin-bottom: 8px;\n}\n\n.ec-email-row {\n    display: flex;\n    gap: 6px;\n}\n\n.ec-email-row .ec-input {\n    flex: 1;\n}\n\n.ec-add-btn {\n    background: #f59e0b;\n    color: #ffffff;\n    border: none;\n    border-radius: 6px;\n    padding: 6px 12px;\n    font-weight: 700;\n    font-size: 0.85rem;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background 0.15s ease;\n}\n\n.ec-add-btn:hover {\n    background: #d97706;\n}\n\n.ec-error {\n    display: block;\n    color: #dc2626;\n    font-size: 0.78rem;\n    margin-top: 5px;\n}\n\n/* =================== CHIPS =================== */\n.ec-chip-list {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 4px;\n    margin-top: 5px;\n}\n\n.ec-view-report .ec-view-row {\n    flex-direction: column;\n    gap: 4px;\n}\n\n.ec-view-report .ec-chip-list {\n    margin-top: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.ec-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    background: #f3f4f6;\n    border: 1px solid #e5e7eb;\n    border-radius: 999px;\n    padding: 2px 8px;\n    font-size: 0.78rem;\n    color: #374151;\n}\n\n.ec-chip-remove {\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    font-size: 1.05rem;\n    line-height: 1;\n    color: #9ca3af;\n    padding: 0;\n    display: flex;\n    align-items: center;\n}\n\n.ec-chip-remove:hover {\n    color: #ef4444;\n}\n\n.ec-chip-trigger {\n    background: #fff4e6;\n    border-color: #fcd34d;\n    color: #b45309;\n}\n\n/* =================== CHECKBOXES =================== */\n.ec-checkboxes {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.ec-checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 10px;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    background: #f9fafb;\n    font-size: 0.82rem;\n    cursor: pointer;\n    user-select: none;\n    transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.ec-checkbox-label:hover {\n    border-color: #f59e0b;\n    background: #fffbf0;\n}\n\n.ec-checkbox-label input[type=\"checkbox\"] {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 15px;\n    height: 15px;\n    border: 2px solid #9ca3af;\n    border-radius: 3px;\n    background: #ffffff;\n    position: relative;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.ec-checkbox-label input[type=\"checkbox\"]:checked {\n    background: #f59e0b;\n    border-color: #f59e0b;\n}\n\n.ec-checkbox-label input[type=\"checkbox\"]:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 3px;\n    top: 0px;\n    width: 4px;\n    height: 8px;\n    border: solid #ffffff;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n/* =================== TRIGGER VERTICAL LIST =================== */\n.ec-trigger-list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-top: 8px;\n}\n\n.ec-trigger-item {\n    border: 1.5px solid #e5e7eb;\n    border-radius: 8px;\n    background: #f9fafb;\n    overflow: hidden;\n    transition: border-color 0.15s ease;\n}\n\n.ec-trigger-item-active {\n    border-color: #f59e0b;\n    background: #fffdf7;\n}\n\n.ec-trigger-item-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    cursor: pointer;\n    user-select: none;\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #374151;\n}\n\n.ec-trigger-item-active .ec-trigger-item-label {\n    color: #b45309;\n}\n\n.ec-trigger-item-matrix {\n    border-top: 1px solid #f3f4f6;\n}\n\n/* =================== TRIGGER MATRIX BLOCK =================== */\n.ec-trigger-matrix-block {\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    background: #f9fafb;\n    margin-top: 8px;\n    overflow: hidden;\n}\n\n.ec-trigger-matrix-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 7px 12px;\n    background: #f3f4f6;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.ec-trigger-matrix-title {\n    font-size: 0.78rem;\n    font-weight: 700;\n    color: #374151;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* keep old .ec-trigger-label for any remaining uses */\n.ec-trigger-label {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #374151;\n}\n\n/* =================== MONTH SUB-GROUP =================== */\n.ec-month-subgroup {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 8px;\n    background: #fffdf7;\n}\n\n.ec-month-subitem {\n    background: #ffffff;\n}\n\n.ec-month-subitem.ec-trigger-item-active {\n    background: #fffdf7;\n}\n\n.ec-month-hint {\n    font-size: 0.72rem;\n    font-weight: 500;\n    color: #9ca3af;\n    text-transform: none;\n    letter-spacing: 0;\n}\n\n/* radio used for the mutually-exclusive Month End / Month Start choice */\n.ec-radio-check {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 15px;\n    height: 15px;\n    border: 2px solid #9ca3af;\n    border-radius: 50%;\n    background: #ffffff;\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    flex-shrink: 0;\n}\n\n.ec-radio-check:checked {\n    border-color: #f59e0b;\n}\n\n.ec-radio-check:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 3px;\n    top: 3px;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #f59e0b;\n}\n\n/* =================== REPORT FORMAT MATRIX =================== */\n.ec-matrix {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 0;\n    background: #ffffff;\n    font-size: 0.8rem;\n}\n\n.ec-matrix-th {\n    background: #f3f4f6;\n    padding: 5px 8px;\n    text-align: center;\n    font-size: 0.75rem;\n    font-weight: 700;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.ec-matrix-report-col {\n    text-align: left;\n    width: 55%;\n}\n\n.ec-matrix-fmt-col {\n    width: 22%;\n}\n\n.ec-matrix-row:not(:last-child) td {\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.ec-matrix-label {\n    padding: 5px 8px;\n    font-size: 0.8rem;\n    color: #374151;\n}\n\n.ec-matrix-cell {\n    text-align: center;\n    padding: 5px 4px;\n}\n\n.ec-matrix-check {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 15px;\n    height: 15px;\n    border: 2px solid #9ca3af;\n    border-radius: 3px;\n    background: #ffffff;\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n}\n\n.ec-matrix-check:checked {\n    background: #f59e0b;\n    border-color: #f59e0b;\n}\n\n.ec-matrix-check:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 3px;\n    top: 0px;\n    width: 4px;\n    height: 8px;\n    border: solid #ffffff;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n/* =================== CUSTOM SCHEDULE =================== */\n.ec-custom-sched {\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    background: #ffffff;\n    padding: 8px 10px;\n    margin-top: 8px;\n}\n\n.ec-custom-sched-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n.ec-custom-sched-title {\n    font-size: 0.78rem;\n    font-weight: 700;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n}\n\n.ec-custom-sched-fields {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 8px;\n}\n\n.ec-custom-sched-fields .ec-field-group {\n    flex: 1;\n    margin-bottom: 0;\n}\n\n/* smaller + button inside trigger header */\n.ec-plus-sm {\n    width: 22px !important;\n    height: 22px !important;\n    font-size: 1.1rem !important;\n    box-shadow: none !important;\n}\n\n/* =================== ICON BUTTONS =================== */\n.ec-icon-btn {\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    padding: 4px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.ec-view-actions {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n}\n\n.ec-edit-btn {\n    color: #6b7280;\n    border: 1px solid #e5e7eb;\n    padding: 5px 7px;\n    background: #ffffff;\n    border-radius: 6px;\n}\n\n.ec-edit-btn:hover {\n    color: #f59e0b;\n    border-color: #fcd34d;\n    background: #fffbf0;\n}\n\n.ec-delete-btn {\n    color: #9ca3af;\n    border: 1px solid #e5e7eb;\n    padding: 5px 7px;\n    background: #ffffff;\n    border-radius: 6px;\n}\n\n.ec-delete-btn:hover {\n    color: #ef4444;\n    border-color: #fecaca;\n    background: #fef2f2;\n}\n\n.ec-remove-btn {\n    color: #9ca3af;\n    font-size: 0.85rem;\n    width: 26px;\n    height: 26px;\n    border-radius: 6px;\n}\n\n.ec-remove-btn:hover {\n    color: #ef4444;\n    background: #fee2e2;\n}\n\n/* =================== EMPTY HINT =================== */\n.ec-empty-hint {\n    color: #9ca3af;\n    font-size: 0.85rem;\n    margin: 4px 0 0;\n    font-style: italic;\n}\n\n/* =================== FORM ACTIONS =================== */\n.ec-form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid #f3f4f6;\n}\n\n.ec-save-btn {\n    background: #f59e0b;\n    color: #ffffff;\n    border: none;\n    border-radius: 6px;\n    padding: 7px 20px;\n    font-weight: 700;\n    font-size: 0.9rem;\n    cursor: pointer;\n    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.25);\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.ec-save-btn:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(245, 158, 11, 0.35);\n}\n\n.ec-save-btn:disabled {\n    background: #d1d5db;\n    cursor: not-allowed;\n    opacity: 0.6;\n    box-shadow: none;\n}\n\n.ec-cancel-btn {\n    background: #f3f4f6;\n    color: #374151;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    padding: 7px 16px;\n    font-weight: 600;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: background 0.15s ease;\n}\n\n.ec-cancel-btn:hover {\n    background: #e5e7eb;\n}\n\n/* =================== CARDS GRID =================== */\n.ec-cards-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n/* =================== VIEW CARD =================== */\n.ec-view-card {\n    background: #ffffff;\n    border-radius: 12px;\n    border: 1px solid #e5e7eb;\n    box-shadow: 0 3px 10px rgba(15, 23, 42, 0.05);\n    overflow: hidden;\n}\n\n.ec-view-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 16px;\n    border-bottom: 1px solid #f3f4f6;\n    background: #f9fafb;\n}\n\n.ec-view-title {\n    font-size: 0.88rem;\n    font-weight: 700;\n    color: #111827;\n    letter-spacing: 0.3px;\n}\n\n.ec-view-body {\n    padding: 10px 16px;\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.ec-view-row {\n    display: flex;\n    gap: 10px;\n    align-items: flex-start;\n    margin-bottom: 5px;\n}\n\n.ec-view-row:last-child {\n    margin-bottom: 0;\n}\n\n.ec-view-label {\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: #9ca3af;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    min-width: 50px;\n    padding-top: 3px;\n    flex-shrink: 0;\n}\n\n.ec-view-value {\n    font-size: 0.875rem;\n    color: #374151;\n}\n\n/* =================== TRIGGER GRID (inside card) =================== */\n.ec-view-trigger-grid {\n    display: flex;\n    border-top: 1px solid #f3f4f6;\n    overflow-x: auto;\n}\n\n.ec-view-trigger-col {\n    flex: 1 1 0;\n    min-width: 140px;\n    border-right: 1px solid #f3f4f6;\n}\n\n.ec-view-trigger-col:last-child {\n    border-right: none;\n}\n\n.ec-view-trigger-col-header {\n    padding: 6px 12px;\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: #b45309;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    background: #fffbf0;\n    border-bottom: 1px solid #fde68a;\n}\n\n.ec-view-trigger-col-body {\n    padding: 8px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.ec-view-trigger-report-row {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.ec-view-trigger-report-name {\n    font-size: 0.75rem;\n    color: #374151;\n}\n\n.ec-view-trigger-report-row .ec-chip-list {\n    margin-top: 0;\n}\n\n.ec-view-trigger-empty {\n    font-size: 0.85rem;\n    color: #d1d5db;\n}\n\n.ec-view-custom-sched-entry {\n    padding-bottom: 6px;\n    border-bottom: 1px dashed #f3f4f6;\n}\n\n.ec-view-custom-sched-entry:last-child {\n    padding-bottom: 0;\n    border-bottom: none;\n}\n\n.ec-view-custom-sched-label {\n    display: block;\n    font-size: 0.72rem;\n    font-weight: 600;\n    color: #6b7280;\n    margin-bottom: 4px;\n}\n\n/* =================== DIALOG =================== */\n.ec-dialog-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1300;\n    padding: 20px;\n}\n\n.ec-dialog {\n    background: #ffffff;\n    border-radius: 16px;\n    box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);\n    width: 100%;\n    max-width: 640px;\n    min-height: 300px;\n    max-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    animation: ec-dialog-in 0.18s ease;\n}\n\n@keyframes ec-dialog-in {\n    from { opacity: 0; transform: translateY(12px) scale(0.98); }\n    to   { opacity: 1; transform: translateY(0)   scale(1);    }\n}\n\n.ec-dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 22px 14px;\n    background: #f9fafb;\n    border-bottom: 1px solid #e5e7eb;\n    flex-shrink: 0;\n}\n\n.ec-dialog-title {\n    font-size: 1rem;\n    font-weight: 700;\n    color: #111827;\n    letter-spacing: 0.2px;\n}\n\n.ec-dialog-close {\n    color: #9ca3af;\n    font-size: 1rem;\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.15s, color 0.15s;\n}\n\n.ec-dialog-close:hover {\n    color: #ef4444;\n    background: #fee2e2;\n}\n\n.ec-dialog-body {\n    overflow-y: auto;\n    flex: 1;\n    padding: 0;\n}\n\n.ec-dialog-body::-webkit-scrollbar {\n    width: 5px;\n}\n\n.ec-dialog-body::-webkit-scrollbar-track {\n    background: #f3f4f6;\n}\n\n.ec-dialog-body::-webkit-scrollbar-thumb {\n    background: #d1d5db;\n    border-radius: 999px;\n}\n\n.ec-dialog-body .ec-form-card {\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n    margin-bottom: 0;\n    max-width: 100%;\n}\n\n.ec-dialog-body .ec-form-card .ec-form-actions {\n    padding: 12px 16px;\n    margin-top: 0;\n    border-top: 1px solid #f3f4f6;\n}\n\n/* =================== SWEETALERT SUCCESS =================== */\n.emailconfig-success .swal2-title,\n.emailconfig-success .swal2-html-container {\n    text-align: center !important;\n}\n\n.emailconfig-success .swal2-title {\n    margin-top: 16px !important;\n    margin-bottom: 8px !important;\n}\n\n.emailconfig-success .swal2-icon {\n    margin-top: 8px !important;\n    margin-bottom: 12px !important;\n}\n\n.emailconfig-success .swal2-html-container {\n    margin-bottom: 8px !important;\n}\n\n.emailconfig-success .swal2-actions {\n    margin-top: 4px !important;\n    justify-content: center !important;\n}\n\n.swal2-confirm {\n    background: #f97316 !important;\n    border-radius: 6px !important;\n    padding: 8px 18px !important;\n    font-weight: 700 !important;\n}\n\n.swal2-cancel {\n    background: #6b7280 !important;\n    color: #ffffff !important;\n    border-radius: 6px !important;\n    padding: 8px 18px !important;\n    font-weight: 700 !important;\n}\n\n/* =================== RESPONSIVE =================== */\n@media (max-width: 640px) {\n    .ec-form-card,\n    .ec-view-card {\n        padding: 14px 16px;\n    }\n\n    .ec-custom-trigger {\n        flex-direction: column;\n    }\n\n    .ec-checkboxes {\n        gap: 6px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
